<template>
  <div>
    <ul class="special-attribute-list">
      <li
        v-for="(item, index) in filterItems"
        :key="index"
        :class="`special-attribute-list__item ${item.attribute.isWritable ? 'special-attribute-list__item--edit' : ''} ${getBooleanClass(item.attribute)}`"
        @click="editAttribute(item.attribute)"
      >
        <span class="special-attribute-list__icon"><img src="@/assets/img/paletIcon.png" :alt="item" v-if="item"/></span>
        <span class="special-attribute-list__title">
          {{ attributeLabel(item.attribute) }}
        </span>
        <span class="special-attribute-list__value">
          <template v-if="item.attribute.pivot.override != null">
            <div v-if="!isBooleanValue(item.attribute.pivot.override)">{{ item.attribute.pivot.override }}</div>
            <div v-else>&nbsp;</div>
          </template>
          <template v-else>
            <div v-if="!isBooleanValue(item.attribute.pivot.value)">{{ item.attribute.pivot.value }}</div>
            <div v-else>&nbsp;</div>
          </template>
        </span>
      </li>
    </ul>
    <Dialog :dialogSettings="dialog" :itemEdited="editedItem" :propBundle="bundle" @closeModal="closeModal" @changeAttribute="changeAttribute" />
  </div>
</template>

<script>
import { EditAttributeDialogMixin } from "@/components/item/EditAttributeDialogMixin";
import Dialog from "./Dialog.vue";
export default {
  name: "SpecialAttributeList",
  mixins: [EditAttributeDialogMixin],
  components:{
    Dialog,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    bundle: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterItems: [],
    };
  },
  created() {
    this.initFilterItems();
  },
  watch: {
    items: {
      handler() {
        this.initFilterItems();
      },
      deep: true,
    },
  },
  computed: {
    isBooleanValue() {
      return (value) => {
        return ["true", 'false'].includes(value) || typeof value == 'boolean';
      }
    },
    getBooleanClass(){
      return (attribute) => {
        const value = attribute.pivot.override != null? attribute.pivot.override: attribute.pivot.value;
        if(!this.isBooleanValue(value)) return '';
        return value == 'true' ? 'special-attribute-list__item--true': 'special-attribute-list__item--false';

      }
    },
    attributeLabel(){
      return (attribute) => {
        const langShortCode = this.$store.getters.langShortcode;
        if(attribute.displayName[langShortCode]) return attribute.displayName[langShortCode];
        return this.$t("ARTICLE-BUNDLE-ATTRIBUTE-" + attribute.name.toUpperCase());
      }
    }
  },
  methods: {
    initFilterItems() {
      this.filterItems = this.items.filter((el) =>{
        if([
          "tiltable",
          "bridge_percentage",
          "overhang_percentage",
          "transparent",
          "friction",
          "stamp_force",
          "strength",
          "loading_hint",
          "area_pressure",
          "container_suggestion"
        ].includes(el.attribute.name)){
          if(el.attribute.name !== 'container_suggestion')return true;
          if(el.attribute.pivot.override || el.attribute.pivot.value) return true;
        }
        return false;
      }
        
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.special-attribute-list {
  display: flex;
  list-style: none;
  justify-content: space-evenly;
  margin-bottom: 0em;
  margin-top: 1em;

  &__item {
    position: relative;
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100px;
    &--edit > * {
      cursor: pointer;
      // color: #343434 !important;
    }

    &--false{
      opacity: 0.5;
    }

    &--true{
      opacity: 1;
    }
  }

  &__icon {
    flex: 0 1 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    & img {
      display: block;
      max-width: 30px;
      height: auto;
      -webkit-filter: grayscale(100%) brightness(50%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%) brightness(50%);
      // filter: grayscale(100%)  brightness(50%);
    }
  }

  &__title,
  &__value {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #666666;
  }
}
</style>
